import React from 'react'
import { useTranslation } from 'react-i18next'
import { useAppStore } from '../../store/useAppStore'
import { Document } from '../../types'
import { PageItem } from './PageItem'

interface PageListProps {
  documents?: Document[]
}

export const PageList: React.FC<PageListProps> = ({ documents: docList }) => {
  const { t } = useTranslation()
  const { documents: storeDocuments, currentDocument, setCurrentDocument, toggleSidebar } = useAppStore()
  const documents = docList ?? storeDocuments

  const handleSelect = (doc: Document) => {
    setCurrentDocument(doc)
    // 在移动端点击后自动关闭侧边栏
    if (window.innerWidth < 768) {
      toggleSidebar()
    }
  }

  const sortedDocuments = React.useMemo(() => {
    return [...documents].sort((a, b) => b.updated - a.updated)
  }, [documents])

  if (documents.length === 0) {
    return (
      <div
        className="p-4 text-center"
        style={{
          color: 'var(--text-tertiary)'
        }}
      >
        <p className="text-sm">{t('sidebar.emptyState.noDocuments')}</p>
        <p className="text-xs mt-1">{t('sidebar.emptyState.createFirst')}</p>
      </div>
    )
  }

  return (
    <div className="py-2">
      {sortedDocuments.map((doc) => (
        <PageItem
          key={doc.id}
          document={doc}
          isActive={currentDocument?.id === doc.id}
          onClick={() => handleSelect(doc)}
        />
      ))}
    </div>
  )
}